import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./lib/auth-context";
import { AppShell } from "./shell/AppShell";
import { Login } from "./modules/Login";
import { Register } from "./modules/Register";
import { Dashboard } from "./modules/Dashboard";
import { PoResult } from "./modules/po/PoResult";
import { PoSplit } from "./modules/po/PoSplit";
import { PoProposals } from "./modules/po/PoProposals";
import { PoConfirmedReport } from "./modules/po/PoConfirmedReport";
import { PoProposalHistory } from "./modules/po/PoProposalHistory";
import { PoAuditLog } from "./modules/po/PoAuditLog";
import { SlaResult } from "./modules/sla/SlaResult";
import { SlaSplit } from "./modules/sla/SlaSplit";
import { SlaProposals } from "./modules/sla/SlaProposals";
import { FirmSlaResult } from "./modules/sla/FirmSlaResult";
import { SlaConfirmedReport } from "./modules/sla/SlaConfirmedReport";
import { SlaProposalHistory } from "./modules/sla/SlaProposalHistory";
import { SlaAuditLog } from "./modules/sla/SlaAuditLog";
import { DpoForecast } from "./modules/DpoForecast";
import { Vcc } from "./modules/Vcc";
import { Asn } from "./modules/Asn";
import { Wip } from "./modules/Wip";
import { Rsds } from "./modules/Rsds";
import { Crppc } from "./modules/Crppc";
import { Quality } from "./modules/Quality";
import { Etariff } from "./modules/Etariff";
import { UserAdmin } from "./modules/UserAdmin";
import { Usage } from "./modules/Usage";
import { Freight } from "./modules/Freight";
import { Config } from "./modules/Config";

function Protected({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-sm text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route
        element={
          <Protected>
            <AppShell />
          </Protected>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/po-result" element={<PoResult />} />
        <Route path="/po-split" element={<PoSplit />} />
        <Route path="/po-proposals" element={<PoProposals />} />
        <Route path="/po-confirmed-report" element={<PoConfirmedReport />} />
        <Route path="/po-proposal-history" element={<PoProposalHistory />} />
        <Route path="/po-audit-log" element={<PoAuditLog />} />
        <Route path="/sla-result" element={<SlaResult />} />
        <Route path="/sla-split" element={<SlaSplit />} />
        <Route path="/sla-proposals" element={<SlaProposals source="confirmation" />} />
        <Route path="/firmsla-result" element={<FirmSlaResult />} />
        <Route path="/firmsla-proposals" element={<SlaProposals source="firm_change" />} />
        <Route path="/sla-confirmed-report" element={<SlaConfirmedReport />} />
        <Route path="/sla-proposal-history" element={<SlaProposalHistory />} />
        <Route path="/sla-audit-log" element={<SlaAuditLog />} />
        <Route path="/dpo-forecast" element={<DpoForecast />} />
        <Route path="/vcc" element={<Vcc />} />
        <Route path="/asn" element={<Asn />} />
        <Route path="/wip" element={<Wip />} />
        <Route path="/rsds" element={<Rsds />} />
        <Route path="/crppc" element={<Crppc />} />
        <Route path="/quality" element={<Quality />} />
        <Route path="/etariff" element={<Etariff />} />
        <Route path="/useradmin" element={<UserAdmin />} />
        <Route path="/usage" element={<Usage />} />
        <Route path="/freight" element={<Freight />} />
        <Route path="/config" element={<Config />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
